import type { AwardItem, AwardScope } from "~/entities/MediaAndAwardsEntities";
import type { HttpResponse } from "~/types/general";

export const useAwardsList = async (type: AwardScope, page: number) =>
  useFetchSafely<HttpResponse<AwardItem[]>>(`${type}/list`, {
    params: {
      page,
    },
  });
